export const server =
  process.env.REACT_APP_ENV === "production"
    ? "https://api.iiscore-u.net"
    : process.env.REACT_APP_ENV === "staging"
    ? "https://api.stg.iiscore-u.net"
    : process.env.REACT_APP_ENV === "develop"
    ? "https://api.dev.iiscore-u.net"
    : "http://localhost:5299";

export const webAPIUrl = `${server}/api`;

export const front_server =
  process.env.REACT_APP_ENV === "production"
    ? "https://iiscore-u.net"
    : process.env.REACT_APP_ENV === "staging"
    ? "https://stg.iiscore-u.net"
    : process.env.REACT_APP_ENV === "develop"
    ? "https://dev.iiscore-u.net"
    : "http://localhost:5299";

export const userTypeCodeODK_SU = "ODK_SU";
export const userTypeCodeUNIV_SU = "UNIV_SU";
export const userTypeCodeUNIV_HEAD = "UNIV_HEAD";
export const userTypeCodeUNIV_GRADER = "UNIV_GRADER";
export const userTypeNameUNIV_SU = "大学.スーバーユーザ";

export const rubricScoringPatternType = {
  "1": "ルーブリック基本",
  "2": "カテゴリ別",
  "3": "ディスカッション",
  "4": "合計得点のみ",
  "5": "グループ面接",
  "6": "評価コメントのみ",
  "7": "評価コメントのみ",
  "8": "グループ面接(評価コメントつき)",
  "9": "評価点選択式",
};
